import { WorkspaceAiBusinessProfileRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/ai-business-profile')({
  component: WorkspaceAiBusinessProfileRoute,
});
